import { Reducer } from '@reduxjs/toolkit'

import {
  ActionTypes,
  GET_EXPENSES_REPORT_FAILURE,
  GET_EXPENSES_REPORT_REQUEST,
  GET_EXPENSES_REPORT_SUCCESS,
} from './ActionTypes'
import { IState } from './IState'

const initialState: IState = {
  list: undefined,
}

export const expensesReducer: Reducer<IState, ActionTypes> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_EXPENSES_REPORT_REQUEST:
      return {
        ...state,
      }
    case GET_EXPENSES_REPORT_SUCCESS:
      return {
        ...state,
        list: action.payload.report,
      }
    case GET_EXPENSES_REPORT_FAILURE:
      return {
        ...state,
        list: [],
      }
    default:
      return state
  }
}
